module.exports = __webpack_public_path__ + "3c176d751ce70caebbc80dd689ae3e12.woff2";